<div
	*ngIf="!loading; else loadingTpl"
	class="formation-signature__container container-fluid px-0 px-xl-5 py-4 py-xl-5"
>
	<!-- Thematique Header -->
	<div
		*ngIf="thematique && thematiqueDetails"
		class="details-formation-thematique-container mb-4"
	>
		<div class="row mx-0">
			<div
				class="col-12 col-md-auto d-flex align-items-center py-3 pl-4 container-avatar"
			>
				<nz-avatar
					*ngIf="thematiqueDetails.avatarSponsor"
					[nzSrc]="thematiqueDetails.avatarSponsor"
				></nz-avatar>
				<nz-avatar
					*ngIf="!thematiqueDetails.avatarSponsor"
					nzIcon="user"
				></nz-avatar>
			</div>
			<div
				class="col-12 col-md d-flex flex-column justify-content-center py-3 infos-thematique-container"
			>
				<h2 class="thematique-title mb-0">
					{{ thematiqueDetails.name }}
				</h2>
				<p class="thematique-meta mb-0">
					<span class="name-sponsor-formation">
						{{ thematiqueDetails.formationName }}
					</span>
					<span class="label-formateur">Géré par :</span>
					<span class="number-respondants-formation">{{
						thematiqueDetails.sponsor
					}}</span>
					|
					<span>{{ thematiqueDetails.respondantsMax }}</span>
					stagiaire<span *ngIf="thematiqueDetails.respondantsMax > 1"
						>s</span
					>
					<br />
					<span class="coachs-thematique-formation">
						<span class="label-formateur">Formateur :</span>
						{{ thematiqueDetails.coach }}
					</span>
				</p>
			</div>
			<div
				class="bandeau"
				[ngStyle]="
					colorThematique.props.gradient_min &&
					colorThematique.props.gradient_max
						? {
								background:
									'linear-gradient(180deg, ' +
									colorThematique.props.gradient_min +
									', ' +
									colorThematique.props.gradient_max +
									')'
						  }
						: {
								background: colorThematique.props.main
						  }
				"
			></div>
		</div>
	</div>

	<!-- Signature Section -->
	<div class="signature-content container-xl px-xl-0">
		<div class="row">
			<div class="col-12">
				<div
					class="signature-card"
					*ngIf="!processing && signatureTimestamp && signaturePeriod"
				>
					<div class="signature-header">
						<h3 class="signature-title">Attestation de présence</h3>
						<div class="signature-info">
							<div class="info-row">
								<span class="info-label">Date :</span>
								<span class="info-value">{{
									getFormattedDate()
								}}</span>
							</div>
							<div class="info-row">
								<span class="info-label">Période :</span>
								<span class="info-value">{{
									getPeriodLabel()
								}}</span>
							</div>
						</div>
					</div>

					<div class="signature-body">
						<div class="signature-instructions">
							<p>Signez dans le cadre ci-dessous :</p>
							<p class="signature-instructions__hint">
								Merci d’apposer une vraie signature.
							</p>
						</div>
						<div class="signature-canvas-wrapper">
							<signature-pad
								#signature
								[options]="signaturePadOptions"
								(drawEnd)="drawComplete($event)"
							>
							</signature-pad>
						</div>
						<div
							*ngIf="signatureError"
							class="signature-error"
							role="alert"
						>
							<i nz-icon nzType="exclamation-circle"></i>
							{{ signatureError }}
						</div>
					</div>

					<div class="signature-footer">
						<button
							nz-button
							nzType="default"
							nzSize="large"
							(click)="navigateBack()"
							class="mr-3"
						>
							<i nz-icon nzType="arrow-left"></i>
							Retour à la thématique
						</button>
						<button
							nz-button
							nzType="default"
							nzSize="large"
							(click)="clearSignature()"
							class="mr-3"
						>
							<i nz-icon nzType="delete"></i>
							Effacer
						</button>
						<button
							nz-button
							nzType="primary"
							nzSize="large"
							[disabled]="!readyToSave"
							(click)="submitSignature()"
						>
							<i nz-icon nzType="check"></i>
							Signer
						</button>
					</div>
				</div>

				<!-- Processing State -->
				<div class="signature-processing" *ngIf="processing">
					<app-atom-concept-loader></app-atom-concept-loader>
					<p class="processing-text">
						Enregistrement de votre signature en cours...
					</p>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #loadingTpl>
	<div class="text-center my-5 py-5">
		<app-atom-concept-loader></app-atom-concept-loader>
	</div>
</ng-template>
